import { httpRequest } from '@shared/api/httpRequests'

/**
 * Fire a smartconnect rule via the legacy `/Queue/1/PageEvent/{ruleId}` endpoint.
 *
 * PG&E pages drive interactive actions (approve/reject/disable/etc.) through
 * Python rules whose IDs are returned alongside row data. This helper mirrors
 * the Vue2 pattern from `qadocontractors.newcollab/companymanagement/frontend/src/api/index.js`
 * so customer-specific Vue3 views can post to the same endpoint without a
 * page-load `pageVars` blob.
 *
 * @param {number|string} ruleId  Numeric rule ID returned by the backend
 * @param {Object}        ruleParams  Arbitrary params forwarded to the rule
 * @returns {Promise<Object>}  Parsed `data.enum` payload from the rule response
 * @throws {Error} If the rule response is malformed or contains an `error` flag
 */
export async function triggerRule (ruleId, ruleParams = {}) {
  if (!ruleId) {
    throw new Error('triggerRule: missing ruleId')
  }

  const response = await httpRequest({
    method: 'POST',
    url: `/Queue/1/PageEvent/${ruleId}`,
    data: ruleParams,
  })

  if (!response || !response.enum) {
    throw new Error('triggerRule: invalid server response')
  }
  if (response.enum.error) {
    throw new Error(response.enum.error)
  }
  return response.enum
}
